import { Stack } from "@mui/material";

type Props = {
  currentQuestion: any;
};

const DateField = ({ currentQuestion }: Props) => {
  const { responses } = currentQuestion;

  return (
    <Stack gap={1} direction={"row"} alignItems={"center"}>
      <div style={{ fontSize: "14px" }}>{responses?.[0]?.textValue || ""}</div>
    </Stack>
  );
};
export default DateField;
